import {
  createBootstrapFailure,
  createDashboardErrorBoundary,
} from '../../../shared/bootstrap-failure.mjs';

export const BootstrapFailure = createBootstrapFailure();
export const DashboardErrorBoundary = createDashboardErrorBoundary();
